module.exports = __webpack_public_path__ + "img/product_63.9a28c44.svg";